import {
  CHARACTER_SEPARATOR_DEVICE_NAME,
  DEVICE_NAME,
} from '../components/CycleChartPreview/constants';
import { CycleController } from '../store/models/controllers';
import { IChannelName } from '../types/channel-types';
import generateIdDevice from './generateIdDevice';

const generateDefaultDeviceName = (typeDevice: string, number: string) => {
  return `${DEVICE_NAME[typeDevice]}${CHARACTER_SEPARATOR_DEVICE_NAME}${number}`;
}

const getDeviceNames = async (
  cycleControllers: CycleController[],
  promises: Promise<IChannelName[]>[],
): Promise<{ [key: string]: string; }> => {

  const channels = (await Promise.allSettled(promises))
    .map((item) => {
      if (item.status === 'fulfilled') {
        return item.value;
      } else {
        console.error(item.reason);
        return [];
      }
    })
    .flat() as IChannelName[];

  const deviceNamesById = {};

  const channelNames = channels.reduce((accumulator, channel) => {
    if (channel.name?.trim().length > 0) {
      accumulator[channel.id] = channel.name.trim();
    } else {
      const deviceNameData = channel.channel.split(CHARACTER_SEPARATOR_DEVICE_NAME);
      const deviceType = deviceNameData[0];
      const deviceNumber = deviceNameData[1];
      const formattedDevice = DEVICE_NAME[deviceType] + CHARACTER_SEPARATOR_DEVICE_NAME + deviceNumber;

      accumulator[channel.id] = formattedDevice;
    }

    return accumulator;
  }, {});

  cycleControllers.reduce((acc, item) => {
    const serialNumber = item.controller.serial_number;

    item.thermocouples.forEach((tc) => {
      const [prefix, number] = tc.split(CHARACTER_SEPARATOR_DEVICE_NAME);
      const formattedName = generateDefaultDeviceName(prefix, number);
      const idDevice = generateIdDevice(serialNumber, tc);
      acc[idDevice] = formattedName;
    });

    item.channels.forEach((channel) => {
      const idDevice = generateIdDevice(serialNumber, channel);

      if (channelNames[idDevice]) {
        acc[idDevice] = channelNames[idDevice];
      } else {
        const [prefix, number] = channel.split(CHARACTER_SEPARATOR_DEVICE_NAME);
        const formattedName = generateDefaultDeviceName(prefix, number);

        acc[idDevice] = formattedName;
      }
    });

    return acc;
  }, deviceNamesById);

  return deviceNamesById;
};

export default getDeviceNames;
